import firebase from 'firebase';
import 'firebase/firestore';

var config = {
    apiKey: "AIzaSyCLRzgRmBzFJSpdLIrmzr2HyHqA7B9JXK0",
    authDomain: "lv-demo.firebaseapp.com",
    databaseURL: "https://lv-demo.firebaseio.com",
    projectId: "lv-demo",
    storageBucket: "lv-demo.appspot.com",
    messagingSenderId: "710293300304"
};

firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore()
const storage = firebase.storage();
const auth = firebase.auth()
const loggedInUser = new Promise((resolve, reject) => {
  auth.onAuthStateChanged( user => {
    if (user) {
      var col = db.collection('users').doc(user.uid);
      col.get()
        .then(doc => {
          if (doc.exists) {
            let u = doc.data();
            // u.displayName = user.displayName || u.displayName;
            u.photoURL = user.photoURL || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAIAAACRXR/mAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMqADAAQAAAABAAAAMgAAAAB1y6+rAA'
            u.lastSignInTime = user.metadata.lastSignInTime || u.lastSignInTime;
            u.uid = user.uid;
            u.email = user.email || u.email;

            resolve(u);
          }
        })
    }
  });
});

export {
    db,
    storage,
    auth,
    loggedInUser   
}
